import { createSlice } from '@reduxjs/toolkit'

import {
  fetchZoneById,
  hydrateZoneFromUserDossier,
  setActiveZone,
} from './zoneThunks'
import { ZoneState } from './types'
import { ZoneDetails } from '../../shared/types'

const initialState: ZoneState = {
  data: <ZoneDetails | null>null,
  loading: false,
  loadingHydrateZone: false,
  error: <string | null>null,
}

const applyActiveZone = (state: ZoneState, zone: ZoneDetails | null) => {
  state.loading = false
  state.data = zone
  state.error = null
}

const zoneSlice = createSlice({
  name: 'zone',
  initialState,
  reducers: {
    resetZone: () => initialState,
    clearZoneError(state) {
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      // setActiveZone (remote mutation)
      .addCase(setActiveZone.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(setActiveZone.fulfilled, (state, action) => {
        applyActiveZone(state, action.payload as ZoneDetails)
      })
      .addCase(setActiveZone.rejected, (state, action) => {
        state.loading = false
        state.error =
          action.payload?.error ?? action.error.message ?? 'Unknown error'
      })

      // fetchZoneById (local hydration)
      .addCase(fetchZoneById.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchZoneById.fulfilled, (state, action) => {
        if (action.meta.arg.applyToState) {
          applyActiveZone(state, action.payload as ZoneDetails)
        }
      })
      .addCase(fetchZoneById.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message ?? 'Unknown error'
      })

      // fetch hydrateZoneFromUserDossire
      // This covers both: fetching the user dossier and activeZone data
      .addCase(hydrateZoneFromUserDossier.pending, (state) => {
        state.loadingHydrateZone = true
      })
      .addCase(hydrateZoneFromUserDossier.fulfilled, (state) => {
        state.loadingHydrateZone = false
      })
      .addCase(hydrateZoneFromUserDossier.rejected, (state) => {
        state.loadingHydrateZone = false
      })
  },
})

// Export the reset action so you can dispatch it
export const { resetZone, clearZoneError } = zoneSlice.actions

// Export the reducer to be used in the store
export default zoneSlice.reducer
